// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.rpc.handler

import org.multipaz.cbor.DataItem
import org.multipaz.rpc.handler.RpcAuthException
import org.multipaz.rpc.handler.RpcExceptionMap
import org.multipaz.cbor.Bstr
import org.multipaz.rpc.handler.toDataItem
import org.multipaz.rpc.handler.fromDataItem

fun RpcAuthException.Companion.register(exceptionMapBuilder: RpcExceptionMap.Builder) {
    exceptionMapBuilder.addException<RpcAuthException>(
        "RpcAuth",
        { exception ->
            exception.toDataItem()
        } ,
        { dataItem ->
            RpcAuthException.fromDataItem(dataItem)
        } ,
        listOf(
            RpcAuthException::class,
            )
    )
}
